import React, { FC } from "react";
import { OidcRedirect } from "./oidc/OidcRedirect";

export const Redirect: FC = () => {
  return <OidcRedirect />;
};
